import { createContext, useState, useMemo, useCallback } from "react";
import PropTypes from "prop-types";

export const ExpandableSidebarStateContext = createContext({
  state: { type: "idle", currentWidth: 0 },
  setType: () => {},
  setCurrentWidth: () => {},
});

export const ExpandableSidebarStateProvider = ({ children }) => {
  const [state, setState] = useState({
    type: "idle",
    currentWidth: 0,
  });

  // Stable setters — functional setState means we don't need state in deps.
  // No-op short-circuit prevents render loops when consumers sync the same width every render.
  const setType = useCallback((next) => {
    const type = typeof next === "string" ? next : next?.type;
    setState((prev) => (prev.type === (type || "idle") ? prev : { ...prev, type: type || "idle" }));
  }, []);

  const setCurrentWidth = useCallback((width) => {
    setState((prev) => (prev.currentWidth === width ? prev : { ...prev, currentWidth: width }));
  }, []);

  const value = useMemo(
    () => ({ state, setType, setCurrentWidth }),
    [state, setType, setCurrentWidth]
  );

  return (
    <ExpandableSidebarStateContext.Provider value={value}>
      {children}
    </ExpandableSidebarStateContext.Provider>
  );
};

ExpandableSidebarStateProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
